import TranslatableText from "@components/translations/TranslatableText";

const HelpCenterHome = () => (
	<div className="help-center__content-block">
		<p className="fs-13 ff-light">
			<TranslatableText translationKey="help_center.home_hint" />
		</p>
	</div>
);

export default HelpCenterHome;
